import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pageheader from './Pageheader'
import Service from '../Home/Service'
import About from '../Home/About'
import Fact from '../Home/Fact'
import Team from '../Home/Team'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'

function AllAbout() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pageheader/>
        <Service/>
        <About/>
        <Fact/>
        <Team/>
        <Footer/>
    </CartProvider>
  )
}

export default AllAbout